import { FC, useEffect, useState } from "react";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import { Box, Stack, Typography } from "@mui/material";
import { Colors } from "../../../styles/constant";
import CustomSwitch from "../../../components/CustomSwitch/CustomSwitch";
import { REGISTER_BIO_METRIC, SCREEN_TYPE } from "../../../utils/constants";
import {
  BIOMETRIC_DO_IT_LATER_STATUS,
  getCookie,
  setCookie,
} from "../../../utils/CSCookieHandler";
import _ from "lodash";
import CsSessionStorageUtils from "../../../utils/CsSessionStorageUtils";
import { useBiometric } from "../../../hooks/useBiometric";
import { T_BiometricCapture } from "../../../globalTypes/GlobalTypes";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import {
  getMobileOperatingSystem,
  generateDeviceID,
} from "../../../utils/helper";
import { useLazyRegisterBiometricQuery } from "../../Feature_Login/Login_Api";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

declare const window: any;

interface Props {
  handleBackBtnClick: Function;
  pathname?: string;
}

const DeviceAuthenticationSettings: FC<Props> = ({
  handleBackBtnClick,
  pathname,
}) => {
  const [isAuthEnable, setIsAuthEnabled] = useState(false);
  const { t } = useAppTranslation("common");

  const initiateBiometricScan = useBiometric("capture");
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const appDispatch = useAppDispatch();
  const [registerBiometricAPI] = useLazyRegisterBiometricQuery();

  const onChangeHandle = (value: boolean) => {
    setIsAuthEnabled(value);
    if (value) {
      initiateBiometric();
    } else {
      setUpBiometricLater();
    }
  };

  useEffect(() => {
    // let bioInfo = null;
    // if(csAppSlice.NativeDeviceInfo?.systemName === 'Android') {
    //   bioInfo = csAppSlice.NativeDeviceInfo?.bioInfo;
    // } else {
    //   bioInfo = JSON.parse(getCookie(REGISTER_BIO_METRIC) as any);
    // }

    const bioInfo = JSON.parse(getCookie(REGISTER_BIO_METRIC) as any);

    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName:
        CT_ScreenEvntDtls.R_GAE.gaDeviceAuthSettingsPerList.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });

    if (!_.isEmpty(bioInfo) && !_.isEmpty(bioInfo?.biometricToken)) {
      setIsAuthEnabled(true);
    } else {
      setIsAuthEnabled(false);
    }
  }, []);

  const setUpBiometricLater = () => {
    setIsAuthEnabled(false);
    console.log("SET BIO LATER");
    CsSessionStorageUtils.set("BIOMETRIC_SETUP_STATUS", false);
    setCookie(BIOMETRIC_DO_IT_LATER_STATUS, "true", 30);
    appDispatch({
      type: REGISTER_BIO_METRIC,
      payload: {},
    });
    if (window.ReactNativeWebView) {
      const message = {
        action: "BIO_INFO",
        payload: {},
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const initiateBiometric = () => {
    initiateBiometricScan("")
      ?.then((result) => {
        onBiometricSuccess(result as T_BiometricCapture);
      })
      .catch((err) => {
        setUpBiometricLater();
      });
  };

  const onBiometricSuccess = (result: T_BiometricCapture) => {
    const reqBodyforRegisterBiometric = {
      csUserId: userDetails?.CS_USER_ID,
      biometricToken: result?.biometricToken,
      mobileOs: getMobileOperatingSystem(),
      mobile: userDetails?.mobileNumber,
      deviceId: generateDeviceID(),
      appVersion: csAppSlice.NativeDeviceInfo?.appVersion,
    };

    registerBiometricAPI(reqBodyforRegisterBiometric)
      .then((res) => {
        if (res.data?.code === 1 && !_.isEmpty(res.data?.payload)) {
          appDispatch({
            type: REGISTER_BIO_METRIC,
            payload: {
              biometricToken: result.biometricToken,
              mobile: reqBodyforRegisterBiometric.mobile,
              csUserId: reqBodyforRegisterBiometric.csUserId,
              deviceId: reqBodyforRegisterBiometric.deviceId,
            },
          });
          if (window.ReactNativeWebView) {
            const message = {
              action: "BIO_INFO",
              payload: {
                biometricToken: result.biometricToken,
                mobile: reqBodyforRegisterBiometric.mobile,
                csUserId: reqBodyforRegisterBiometric.csUserId,
                deviceId: reqBodyforRegisterBiometric.deviceId,
              },
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
            console.log(
              "Sending event to TWA React Native Android " +
                JSON.stringify(message),
            );
          }
          CsSessionStorageUtils.set("BIOMETRIC_SETUP_STATUS", true);
          setCookie(BIOMETRIC_DO_IT_LATER_STATUS, "false", 30);
        } else {
          handleBiometricError(res.data?.message ?? "");
        }
      })
      .catch((err) => {
        handleBiometricError(err.message);
      });
  };

  const handleBiometricError = (message: string) => {
    appDispatch(
      setError({
        error: new Error("Error"),
        message: message || "Save Biometric API Error",
      }),
    );
    setUpBiometricLater();
  };

  return (
    <CommonMenuListPage
      title={t("appSettings.titles.deviceAuthenticationSettings")}
      handleBackBtnClick={handleBackBtnClick}
      pathname={pathname}
    >
      <Stack spacing={"1rem"} paddingLeft={"1rem"} paddingRight={"1rem"}>
        <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
          <Typography variant="h4" color={Colors.arsenic}>
            {t("appSettings.headings.choosePermissions")}
          </Typography>
          <Typography
            variant="h6"
            fontWeight={400}
            color={"#000000"}
            lineHeight={".975rem"}
          >
            {t("appSettings.headings.adjustPreferences")}
          </Typography>
        </Box>
        <Box sx={{ "& > :not(:first-child)": { marginTop: ".25rem" } }}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h5">
              {t("appSettings.labels.deviceAuthentication")}
            </Typography>
            <CustomSwitch
              checked={isAuthEnable}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(value) => {
                //setIsAuthEnabled(value.target.checked);
                onChangeHandle(value.target.checked);
              }}
            />
          </Box>
          <Typography
            variant="h6"
            fontWeight={400}
            lineHeight={".975rem"}
            color={Colors.arsenic}
          >
            {t("appSettings.descriptions.deviceAuthentication")}
          </Typography>
        </Box>
      </Stack>
    </CommonMenuListPage>
  );
};

export default DeviceAuthenticationSettings;
